export default "__VITE_ASSET__CQtg2wI7__"